import { createClient } from "@sanity/client";

const client = createClient({
  projectId: "6n8xy7gd",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-05-03",
});

export default client;
